Coloradical.Utils.loadingProgress = function($images, callback, context) {
	var image_cnt = $images.length,
			images_loaded = 0;

	$images.each(function(i, img){
		if (!img.complete) {
			$(img).load(function() {
				images_loaded++;
				check_images_loaded();
			});
		} else {
			images_loaded++;
		}
	});

	function check_images_loaded() {
		if (images_loaded === image_cnt) {
			if (callback) {
				callback.apply(context);
			}
		}
	};

	check_images_loaded();
};